import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBezierRemove: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBezierRemove"><Path d="M15 11H9V13H15V11Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M3 9V3H9V5H15V3H21V9H19V15H21V21H15V19H9V21H3V15H5V9H3ZM7 9V15H9V17H15V15H17V9H15V7H9V9H7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBezierRemove;
